module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_es-b7dd653b38772270293f0c87a3ee4483.png";